import theme from '../../../../../landing/components/core/themes/theme';
var ColorsByAssessmentResult = {
    far_below: theme.colors.red70,
    below: theme.colors.yellow70,
    meets: theme.colors.green70,
    exceeds: theme.colors.green30,
    tbd: theme.colors.black80,
};
var TABLE_COLUMNS = [
    'total',
    'far_below',
    'below',
    'meets',
    'exceeds',
];
var PROGRESS_BAR_RESULTS = [
    'far_below',
    'below',
    'meets',
    'exceeds',
];
var BAR_CHART_RESULTS = [
    'far_below',
    'below',
    'meets',
    'exceeds',
    'tbd',
];
var ASSESSMENTS = ['primary', 'middle', 'finally'];
var NO_DATA_STATUSES = [
    'assigned',
    'not_started',
    'setup_needed',
    'not_available',
];
var TAB_VISIBLE_STATUSES = [
    'setup_needed',
    'assigned',
    'assigned',
    'in_progress',
];
var DEFAULT_ASSESSMENT = 'primary';
export { ColorsByAssessmentResult, TABLE_COLUMNS, PROGRESS_BAR_RESULTS, ASSESSMENTS, BAR_CHART_RESULTS, NO_DATA_STATUSES, TAB_VISIBLE_STATUSES, DEFAULT_ASSESSMENT, };
